import { render, staticRenderFns } from "./SvgLogoMcp.vue?vue&type=template&id=2f56ed05&"
import script from "./SvgLogoMcp.vue?vue&type=script&lang=js&"
export * from "./SvgLogoMcp.vue?vue&type=script&lang=js&"
import style0 from "./SvgLogoMcp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports